import { render } from "./ProjectNumByUser.vue?vue&type=template&id=a35389a6"
import script from "./ProjectNumByUser.vue?vue&type=script&lang=js"
export * from "./ProjectNumByUser.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__